module.exports = __webpack_public_path__ + "images/podcast_130.c4f56324d09fbb1c044392a7edbcbc76.png";